import { defineStore } from 'pinia'
import { PageEnum } from '/@/enums/pageEnum'
import { getRawRoute } from '@/utils/tools'
import { PAGE_NOT_FOUND_ROUTE, REDIRECT_ROUTE } from '/@/router/routes/basic'
import { toRaw, unref } from 'vue'
import { RouteLocationNormalized, RouteLocationRaw, Router } from 'vue-router'
import { useGo, useRedo } from '/@/hooks/web/usePage'
export default defineStore('multipleTab', {
  state: () => {
    return {
      // 需要缓存的标签页
      cacheTabList: new Set(),
      // 标签页列表
      tabList: []
    }
  },
  // persist: {
  //   enabled: true,
  //   strategies: [
  //     {
  //       key: 'account',
  //       storage: localStorage,
  //       paths: ['user_info']
  //     }
  //   ]
  // },
  // 注意：state的成员名称 与 getter成员名称不能相同
  getters: {
    getTabList(state): RouteLocationNormalized[] {
      return state.tabList
    },
    getCachedTabList(state): string[] {
      return Array.from(state.cacheTabList)
    }
  },

  // actions 支持async/await, actions之间方法互相调用直接用this访问即可
  actions: {
    clearCacheTabs(): void {
      this.cacheTabList = new Set()
    },
    resetState() {
      this.tabList = []
      this.clearCacheTabs()
    },
    // 添加标签页
    async addTab(route: RouteLocationNormalized) {
      const { path, name, fullPath, params, query } = getRawRoute(route)
      // 404 、 登录页 等不加入到标签页
      if (
        path === PageEnum.BASE_LOGIN ||
        // !name ||
        [PAGE_NOT_FOUND_ROUTE.name, REDIRECT_ROUTE.name].includes(name as string)
      ) {
        return
      }

      const newTabList = this.tabList
      let updateIndex = -1
      // 不添加现有的标签页
      const tabHasExits = newTabList.some((tab, index) => {
        updateIndex = index
        return (tab.fullPath || tab.path) === (fullPath || path)
      })
      // console.log(tabHasExits)

      // 如果存在该标签页，则更新
      if (tabHasExits) {
        const curTab = toRaw(newTabList)[updateIndex]
        if (!curTab) return
        curTab.params = params || curTab.params
        curTab.query = query || curTab.query
        curTab.fullPath = fullPath || curTab.fullPath
        newTabList.splice(updateIndex, 1, curTab)
      } else {
        newTabList.push(route)
      }
      // console.log(newTabList)

      // commit('setState', ['tabList', newTabList])
      this.tabList = newTabList

      // dispatch('updateCacheTab')
      this.updateCacheTab()
    },
    // 根据key关闭标签页
    async closeTabByKey(key: string, router: Router) {
      const index = this.tabList.findIndex((item) => (item.fullPath || item.path) === key)
      index !== -1 && (await this.closeTab(this.tabList[index], router))
    },
    // 关闭标签页
    async closeTab(tab: RouteLocationNormalized, router: Router) {
      const getToTarget = (tabItem: RouteLocationNormalized) => {
        const { params, path, query } = tabItem
        return {
          params: params || {},
          path,
          query: query || {}
        }
      }

      const close = (route: RouteLocationNormalized) => {
        const { fullPath, meta: { affix } = {} } = route
        if (affix) {
          return
        }
        const index = this.tabList.findIndex((item) => item.fullPath === fullPath)
        index !== -1 && this.tabList.splice(index, 1)
      }

      const { currentRoute, replace } = router

      const { path } = unref(currentRoute)
      if (path !== tab.path) {
        close(tab)
        return
      }

      let toTarget: RouteLocationRaw = {}
      const index = this.tabList.findIndex((item) => item.path === path)
      // 如果当前标签页为第一个
      if (index === 0) {
        // 只有一个标签页，则跳转到首页，否则跳转到最后一个标签页
        if (this.tabList.length === 1) {
          toTarget = PageEnum.BASE_HOME
        } else {
          // 跳转到最后一个标签页
          const page = this.tabList[index + 1]
          toTarget = getToTarget(page)
        }
      } else {
        // 关闭当前标签页
        const page = this.tabList[index - 1]
        toTarget = getToTarget(page)
      }
      // console.log(toTarget)

      close(currentRoute.value)
      replace(toTarget)
    },
    // 刷新标签页
    async refreshPage(router: Router) {
      const { currentRoute } = router
      const route = unref(currentRoute)
      const name = route.name
      console.log(this.getCachedTabList, '---->getCachedTabList')

      const findTab = this.getCachedTabList.find((item) => item === name)
      if (findTab) {
        this.cacheTabList.delete(findTab)
      }
      const redo = useRedo(router)
      await redo()
    },
    // 更新缓存标签
    async updateCacheTab() {
      const cacheMap: Set<string> = new Set()

      for (const tab of this.tabList) {
        const item = getRawRoute(tab)
        // Ignore the cache
        const needCache = !item.meta?.ignoreKeepAlive
        if (!needCache) {
          continue
        }
        const name = item.name as string
        cacheMap.add(name)
      }
      this.cacheTabList = cacheMap
    }
  }
})
